import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 查询岗位相关配置信息字典
  getRolePermissionDict(data) {
    return request({
      url: '/business/role/rolePermissionDict',
      method: 'POST',
      data
    })
  },
  // 角色列表
  getRoleList(data) {
    return request({
      method: 'POST',
      url: '/business/role/list',
      data
    })
  },
  // 导出角色列表
  exportRoleList(data) {
    return request({
      method: 'POST',
      url: '/business/role/export',
      data
    })
  },
  // 删除角色
  deleteRole(data) {
    return request({
      method: 'POST',
      url: '/business/role/delete',
      data
    })
  },
  // // 获取角色权限列表
  // getRolePermissionList(data) {
  //   return request({
  //     method: 'POST',
  //     url: '/business/permission/list',
  //     data
  //   })
  // },
  // 添加角色
  addRole(data) {
    return request({
      method: 'POST',
      url: '/business/role/add',
      data
    })
  },
  // 更新角色信息
  updateRole(data) {
    return request({
      method: 'POST',
      url: '/business/role/modify',
      data
    })
  },
  // 岗位详情
  getRoleDetail(data) {
    return request({
      url: '/business/role/detail',
      method: 'POST',
      data
    })
  }
}
